import React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { corporateColor } from '../../../theme/colors'
import { DOBRA } from '../../../theme/fonts'
import { Modules } from '../../../context/SeaWater/ControlServices/types'

interface Props {
  modules: Modules[]
}

export const Dimension = ({ modules }: Props) => (
  <View>
    {modules.map((item) => (
      <View style={styles.container} key={item.value}>
        <Text style={styles.title}>{item.name}:</Text>
        <Text style={styles.subTitle}>{item.dimension}</Text>
      </View>
    ))}
  </View>
)

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: 12,
    paddingVertical: 8,
  },

  title: {
    color: corporateColor,
    fontFamily: DOBRA,
    fontSize: 16,
    fontWeight: '500',
    letterSpacing: 0,
  },

  subTitle: {
    color: corporateColor,
    fontFamily: DOBRA,
    fontSize: 16,
    fontWeight: '400',
  },
})
